import { Observable, Subscription } from 'rxjs';

import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { formatDate } from '@angular/common';

import { AppConst } from '../../app-const';
import { EntranceExitEvent } from '../../firestore-models/entrance-exit-event';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-select-entrance-exit-transit-daily-dialog',
  templateUrl: './select-entrance-exit-transit-daily-dialog.component.html',
  styleUrls: ['./select-entrance-exit-transit-daily-dialog.component.css'],
  standalone: false,
  providers: [
    // このコンポーネントとその子要素専用のDateAdapterインスタンスを作成 //(0703)
    { provide: DateAdapter, useClass: NativeDateAdapter },
  ]
})
export class SelectEntranceExitTransitDailyDialogComponent implements OnInit, OnDestroy {

  editForm : FormGroup;
  events: EntranceExitEvent[] = [];
  currentLang: string = 'ja';
  private langChangeSub!: Subscription; // TranslateServiceの購読を管理

  constructor(
    public dialogRef: MatDialogRef<SelectEntranceExitTransitDailyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private dateAdapter: DateAdapter<any>
  ) {
    let entranceExitEventId = '';
    let startDate = null;
    let endDate = null;
    this.events = data.events;
    const parameter = data.parameter;
    if (!!parameter.entrance_exit_event_id) {
      entranceExitEventId = parameter.entrance_exit_event_id;
    }
    if (!!parameter.start_date) {
      const year = parseInt(parameter.start_date.substring(0, 4));
      const month = parseInt(parameter.start_date.substring(4, 6));
      const day = parseInt(parameter.start_date.substring(6, 8));
      startDate = new Date(year, month - 1, day, 0, 0);
    }
    if (!!parameter.end_date) {
      const year = parseInt(parameter.end_date.substring(0, 4));
      const month = parseInt(parameter.end_date.substring(4, 6));
      const day = parseInt(parameter.end_date.substring(6, 8));
      endDate = new Date(year, month - 1, day, 0, 0);
    }
    this.editForm = this.formBuilder.group({
      entrance_exit_event_id: new FormControl({value: entranceExitEventId, disabled: false }, []),
      start_date: new FormControl({value: startDate, disabled: false }, []),
      end_date: new FormControl({value: endDate, disabled: false }, []),
    });
  }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang; //(0703)
    // 1. コンポーネント初期化時に現在の言語でカレンダーを設定
    this.setCalendarLocale(this.currentLang);

    // 2. アプリケーションの言語が変更されたら、カレンダーの言語も動的に追従させる
    this.langChangeSub = this.translate.onLangChange.subscribe(event => {
      this.setCalendarLocale(event.lang);
    });
  }

  /** //(0703)
  * Datepickerのロケールを設定するプライベートメソッド
  * @param lang 設定したい言語コード (例: 'en', 'ja')
  */
  private setCalendarLocale(lang: string): void {
    // 言語に応じたロケールを設定
    const locale = lang === 'en' ? 'en-US' : 'ja-JP';
    this.dateAdapter.setLocale(locale);
  }
  
  ngOnDestroy(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  search(): void {
    const startDate = !!this.start_date.value ? formatDate(this.start_date.value, 'yyyyMMdd', 'en-US') : null;
    const endDate = !!this.start_date.value ? formatDate(this.end_date.value, 'yyyyMMdd', 'en-US') : null;
    const data = {
      entrance_exit_event_id: this.entrance_exit_event_id.value,
      start_date: startDate,
      end_date: endDate,
    }
    this.dialogRef.close(data);
  }

  clearDate(): void {
    this.start_date.setValue(null);
    this.end_date.setValue(null);
  }

  //================================================================================================
  //  getter
  //================================================================================================
  get entrance_exit_event_id(): AbstractControl { return this.editForm.get('entrance_exit_event_id')!; }
  get start_date(): AbstractControl { return this.editForm.get('start_date')!; }
  get end_date(): AbstractControl { return this.editForm.get('end_date')!; }
}
